export const experiences = {
  'Northbridge Insurance': {
    company: 'Northbridge Insurance',
    roles: [
      {
        title: 'AI Solutions Engineer',
        period: 'AUG 2025 – PRESENT',
        responsibilities: [
          'Exploring AI solutions and integrating them into Northbridge systems to enhance automation and operational efficiency.',
          'Designing and deploying new tools and features to streamline data workflows and improve decision-making processes.',
          'Build and deploy LLM-integrated systems, from early-stage prototypes to production-ready products.',
          'Research and test new AI and ML models to evaluate performance, scalability, and business impact.'
        ]
      },
      {
        title: 'Data Engineer (Internship)',
        period: 'JUN 2024 – DEC 2024',
        responsibilities: [
          'Developed an AI-powered chatbot using Retrieval-Augmented Generation (RAG) to translate natural language into SQL queries.',
          'Boosted performance by 40% via prompt engineering with open-source LLMs and Cortex API for contextual interactions.',
          'Automated data workflows using Snowflake and Power BI, delivering dashboards.',
          "Presented the chatbot's value at a company-wide town hall and collaborated with Snowflake's Cortex team to improve the API."
        ]
      }
    ]
  },
  'University of Toronto': {
    company: 'University of Toronto',
    roles: [
      {
        title: 'Student Researcher',
        period: 'JAN 2025 – PRESENT',
        responsibilities: [
          'Exploring how emotional tone (valence and arousal) shapes memory recall and frequency effects.',
          'Design and run computational models analyzing relationships between emotional dimensions and recall probability.',
          'Integrate cognitive science theories with data-driven modeling to simulate human memory processes.',
          'Use Python, pandas, and regression analysis to identify how emotional factors moderate frequency-based recall patterns.',
          'Visualize and interpret model outputs to uncover how emotion influences adaptive memory behavior.'
        ]
      }
    ]
  },
  'Medium AI': {
    company: 'Medium AI',
    roles: [
      {
        title: 'Software Developer',
        period: 'JAN 2025 – APR 2025',
        responsibilities: [
          'Built a medical scribe platform using React and JavaScript.',
          'Implemented a real-time Docker-based microservice that boosted user engagement by 35%.',
          'Integrated GraphQL and AssemblyAI API for automated transcription workflows.',
          'Ensured deployment readiness with end-to-end testing and CI/CD.'
        ]
      }
    ]
  },
  Illuminate: {
    company: 'Illuminate',
    roles: [
      {
        title: 'Internal Outreach Director',
        period: 'MAY 2023 – APR 2025',
        responsibilities: [
          'Led student engagement initiatives focused on computer science, AI, and ethics.',
          'Organized interdisciplinary events and internal communications.',
          'Facilitated growth and connections within the Illuminate community.'
        ]
      }
    ]
  }
};
